  const privacyPolicyContent = (
  <div className="space-y-4 text-sm text-gray-700 leading-relaxed">
    <div>
      <h3 className="font-semibold text-gray-900">Privacy Policy</h3>
      <p className="text-xs text-gray-500">Last Updated: March 29, 2025</p>
    </div>

    <div>
      <h4 className="font-semibold">1. Introduction</h4>
      <p>
        Sembe LLC dba Tydii ("Tydii," "we," "us," or "our") is committed to
        safeguarding your privacy. This Privacy Policy explains how we collect,
        use, disclose, and protect your personal information when you access our
        website, mobile application, and utilize any other aspect of our
        platform.
      </p>
    </div>

    <div>
      <h4 className="font-semibold">2. What Information is Collected</h4>
      <p>We collect various types of information:</p>
      <ul className="list-disc pl-5 space-y-1">
        <li>
          <b>User Information:</b> When you register or utilize our platform, we collect personal data
including your name, email address, phone number, and driver’s license information.
        </li>
        <li>
          <b>Laundry or Order Information:</b> Details related to your laundry orders, such as pickup and
delivery addresses and order preferences will be collected when you place orders.
        </li>
        <li>
          <b>Usage Data:</b> We gather information on your interactions within the platform, including
visited pages and actions taken.
        </li>
        <li>
          <b>Operational Information:</b> Details relating to service providers’ operations like sales
volume, customer volume, sales revenue, operational volume, service performance
metrics, service popularity, and productivity insights.
        </li>
        <li>
          <b>Device Information:</b> Information about your device, such as IP address, browser type, and
operating system, may be collected
        </li>
      </ul>

      <p>
        The collection of this information is required unless specified
        otherwise.
      </p>

      <p>
       Tydii does not collect or hold any payment information. Payments made on our platform are
processed by Stripe and all information you provide for payment is collected and held by Stripe
in accordance with its own terms of service and privacy policy. (
        <a
          href="https://stripe.com/privacy"
          target="_blank"
          rel="noreferrer"
          className="text-blue-600 underline"
        >
          https://stripe.com/privacy
        </a>
        ).
      </p>
    </div>

    <div>
      <h4 className="font-semibold">3. How We Collect Information</h4>
      <ul className="list-disc pl-5 space-y-1">
        <li>
          From Uses of Our Services: We receive information when you use our services, like
during account creation, order placement, communications with Tydii, and order
fulfillment.
        </li>
        <li>
          From Legal Claims, Disputes, Requests, and Orders: We may collect personal
information from third parties, such as law enforcement agencies, government agencies
or authorities, users of our services, or any other party who may be involved in the
matter.
        </li>
      </ul>
    </div>

    <div>
      <h4 className="font-semibold">4. Use of Information</h4>
      <p>We utilize your information for the following purposes:</p>
      <ul className="list-disc pl-5 space-y-1">
        <li>Service Improvement: To provide and enhance our platform.</li>
        <li>Order processing: To process your orders and handle payments.</li>
        <li>Communication: To correspond with you regarding your orders and our services.</li>
        <li>Customer Support: To respond to inquiries and offer customer assistance.</li>
        <li>Marketing: To send promotional offers and updates.</li>
        <li>Analytics: To monitor and analyze usage patterns for service enhancement.</li>
        <li>Any legitimate business purpose.</li>
      </ul>
    </div>

    <div>
      <h4 className="font-semibold">5. Sharing Your Information</h4>
      <p>We may share your personal information with third parties for specific purposes:</p>
      <ul className="list-disc pl-5 space-y-1">
        <li>Service Providers: Third-party service providers assisting in delivering our services,
including payment processing, delivery, and customer support.</li>
        <li>Delivery Operators: Third-party delivery operators (drivers) for delivery support</li>
        <li>Legal Compliance: Disclosure as required by law, court order, or governmental
regulations.</li>
        <li>
         Business Transfers: In the event of a sale, merger, acquisition, joint venture,
assignment, or restructuring of our business or assets, your information may be
transferred.
        </li>
      </ul>
    </div>

    <div>
      <h4 className="font-semibold">6. Data Security</h4>
      <p>
       We use commercially reasonable administrative, technical, and physical security controls to
protect your personal information from unauthorized access. While we implement security
measures to protect your information, we cannot guarantee absolute security due to the
inherent risks of online data transmission.
      </p>
    </div>

    <div>
      <h4 className="font-semibold">7. Children’s Privacy</h4>
      <p>
Our services are not directed at individuals under the age of 16. We do not knowingly collect
personal information from children. If you believe that we have inadvertently collected
information from a child, please contact us, and we will take appropriate measures to delete that
information.
      </p>
    </div>

    <div>
      <h4 className="font-semibold">8. User Choices</h4>
      <p>You have the following options regarding your information:</p>
      <ul className="list-disc pl-5 space-y-1">
        <li>Access and Correction: Access, update, and correct your personal information through
your account settings.</li>
        <li>Unsubscribe: Opt-out from receiving marketing communications at any time.</li>
        <li>Account Deletion: Request the deletion of your account and associated data.</li>
        <li>Cancellation of auto-renewal of subscription services.</li>
      </ul>
    </div>

    <div>
      <h4 className="font-semibold">9. Changes to This Privacy Policy</h4>
      <p>
        We may update this Privacy Policy from time to time. When changes occur, we will revise the
“Last Updated” date at the top of this policy and, if material changes are made, send an email
notifying you that this Privacy Policy has changed to the email address associated with your
account. We encourage you to review this policy periodically for updates.
      </p>
    </div>

    <div>
      <h4 className="font-semibold">10. Contact Information</h4>
      <p>
        For inquiries or concerns about this Privacy Policy, please contact us at:{" "}
        <a
          href="mailto:help@tydii.io"
          className="text-blue-600 underline"
        >
          help@tydii.io
        </a>
      </p>
    </div>

    <p className="font-medium">
      Thank you for choosing Tydii.
    </p>
  </div>
);
export default privacyPolicyContent;